import { VaRInfo } from '@/interfaces/raDashboard.interface'
import { ReportDataCache } from '@/services/report-dashboard/raDashboard.data.service'
import React, { PropsWithChildren } from 'react'

export interface RADashboardDataInformation {
  loading: boolean
  marketValue: number | null
  baseCurrency: string | null
  dataStore: ReportDataCache | null
  varInfo: VaRInfo | null,
  // TODO: Convert these to enums
  covarianceMatrix: string | null,
  riskModel: string | null
}

const initialValue: RADashboardDataInformation = {
  loading: false,
  marketValue: null,
  baseCurrency: null,
  dataStore: null,
  varInfo: null,
  covarianceMatrix: null,
  riskModel: null
}

export const RADashboardDataContext = React.createContext(initialValue)

export default function RADashboardDataContextProvider(
  props: PropsWithChildren<RADashboardDataInformation>,
) {
  const { loading, dataStore, marketValue, baseCurrency, varInfo, covarianceMatrix, riskModel } = props;
  const info: RADashboardDataInformation = {
    loading, dataStore, marketValue, baseCurrency, varInfo, covarianceMatrix, riskModel
  }
  return (
    <RADashboardDataContext.Provider value={info}>
      {props.children}
    </RADashboardDataContext.Provider>
  )
}
